import i18n from '@/i18n';
import { UndergradCycle } from '@/models/undergrad/undergrad-cycle.model';

export interface UndergradCycleState {
  undergradCycles: UndergradCycle[];
  currentCycle: UndergradCycle;
}

const state: UndergradCycleState = {
  undergradCycles: [],
  currentCycle: { id: '0', name: i18n.tc('noPeriod'), blocked: false, disciplineIds: [] },
};

export default state;
